import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DEFAULT_TODO_CATEGORY_NAME } from './todoNoteRowShared';

type Props = {
  id: string;
  name: string;
  color: string;
  active: boolean;
  showActions?: boolean;
  onSelect: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  /** false면 삭제 버튼 숨김. 기본은 ToDo 「일반」만 숨김 */
  deletable?: boolean;
};

export const SortableTodoCategoryChip: React.FC<Props> = ({
  id,
  name,
  color,
  active,
  showActions = false,
  onSelect,
  onEdit,
  onDelete,
  deletable,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const isDefault = name.trim() === DEFAULT_TODO_CATEGORY_NAME;
  const canDelete = deletable ?? !isDefault;
  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.84 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`cp-todo-note-chip-row${active ? ' is-active' : ''}${isDragging ? ' is-dragging' : ''}`}
      {...attributes}
      {...listeners}
    >
      <button
        type="button"
        role="tab"
        aria-selected={active}
        className="cp-todo-note-chip-main"
        onClick={onSelect}
      >
        <span
          className="cp-todo-note-chip-dot"
          style={{
            background: color,
            border:
              isDefault || color.toLowerCase() === '#ffffff'
                ? '1px solid color-mix(in srgb, var(--color-border) 78%, transparent)'
                : 'none',
          }}
          aria-hidden
        />
        {name}
      </button>
      {showActions ? (
        <span className="cp-todo-note-chip-icon-actions">
          <button
            type="button"
            className="cp-todo-note-chip-icon-btn"
            aria-label={`${name} 카테고리 수정`}
            onMouseDown={(e) => e.preventDefault()}
            onPointerDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              onEdit?.();
            }}
          >
            <img src={`${process.env.PUBLIC_URL || ''}/edit.svg`} alt="" className="cp-todo-note-chip-icon" />
          </button>
          {canDelete ? (
            <button
              type="button"
              className="cp-todo-note-chip-icon-btn"
              aria-label={`${name} 카테고리 삭제`}
              onMouseDown={(e) => e.preventDefault()}
              onPointerDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.stopPropagation();
                onDelete?.();
              }}
            >
              <img src={`${process.env.PUBLIC_URL || ''}/Trash.svg`} alt="" className="cp-todo-note-chip-icon" />
            </button>
          ) : null}
        </span>
      ) : null}
    </div>
  );
};
